import { render, staticRenderFns } from "./mod0.vue?vue&type=template&id=56451839&scoped=true&"
import script from "./mod0.vue?vue&type=script&lang=js&"
export * from "./mod0.vue?vue&type=script&lang=js&"
import style0 from "./mod0.vue?vue&type=style&index=0&id=56451839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56451839",
  null
  
)

export default component.exports